import { render, staticRenderFns } from "./Beiratkozok.vue?vue&type=template&id=3596ac67&lang=html&"
import script from "./Beiratkozok.vue?vue&type=script&lang=js&"
export * from "./Beiratkozok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports